import { render, staticRenderFns } from "./rechargeWallet.vue?vue&type=template&id=0fdff6a6&scoped=true"
import script from "./rechargeWallet.vue?vue&type=script&lang=js"
export * from "./rechargeWallet.vue?vue&type=script&lang=js"
import style0 from "./rechargeWallet.vue?vue&type=style&index=0&id=0fdff6a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdff6a6",
  null
  
)

export default component.exports